import adminReducer from './';

export default adminReducer;
